const getVendorInfo = ({ vendorState }) => vendorState.vendedorInfo;

export { getVendorInfo };
